/* tslint:disable */
/* eslint-disable */
/**
 * KNMI exons API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
/**
 * LegacyApi - axios parameter creator
 * @export
 */
export const LegacyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Request for the legacy PHP server, retrieving a image or file.
         * @summary Get a file from the legacy server
         * @param {string} [url] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadLegacyFile: async (url?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/legacy/file`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (url !== undefined) {
                localVarQueryParameter['url'] = url;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Request for the legacy PHP server, retrieving a OPMET file.
         * @summary Get OPMET file from the legacy server
         * @param {string} [icaoCode] 
         * @param {string} [pTt] 
         * @param {string} [pMinushour] 
         * @param {string} [format] 
         * @param {string} [pDept] 
         * @param {string} [section] 
         * @param {string} [pMode] 
         * @param {string} [pDest] 
         * @param {string} [pWaypnts] 
         * @param {string} [pAddairps] 
         * @param {string} [pLowLevelFc] 
         * @param {string} [pSwa] 
         * @param {string} [pRegion] 
         * @param {string} [pValidTime] 
         * @param {string} [pSigwx] 
         * @param {string} [pUwtFl1] 
         * @param {string} [pUwtFl2] 
         * @param {string} [pUwtFl4] 
         * @param {string} [pUwtFl5] 
         * @param {string} [pUwtFl7] 
         * @param {string} [pUwtFl9] 
         * @param {string} [pUwtFl11] 
         * @param {string} [pUwtFl13] 
         * @param {string} [productId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadLegacyOpmetFile: async (icaoCode?: string, pTt?: string, pMinushour?: string, format?: string, pDept?: string, section?: string, pMode?: string, pDest?: string, pWaypnts?: string, pAddairps?: string, pLowLevelFc?: string, pSwa?: string, pRegion?: string, pValidTime?: string, pSigwx?: string, pUwtFl1?: string, pUwtFl2?: string, pUwtFl4?: string, pUwtFl5?: string, pUwtFl7?: string, pUwtFl9?: string, pUwtFl11?: string, pUwtFl13?: string, productId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/legacy/opmet_file`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (icaoCode !== undefined) {
                localVarQueryParameter['icaoCode'] = icaoCode;
            }

            if (pTt !== undefined) {
                localVarQueryParameter['p_tt'] = pTt;
            }

            if (pMinushour !== undefined) {
                localVarQueryParameter['p_minushour'] = pMinushour;
            }

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }

            if (pDept !== undefined) {
                localVarQueryParameter['p_dept'] = pDept;
            }

            if (section !== undefined) {
                localVarQueryParameter['section'] = section;
            }

            if (pMode !== undefined) {
                localVarQueryParameter['p_mode'] = pMode;
            }

            if (pDest !== undefined) {
                localVarQueryParameter['p_dest'] = pDest;
            }

            if (pWaypnts !== undefined) {
                localVarQueryParameter['p_waypnts[]'] = pWaypnts;
            }

            if (pAddairps !== undefined) {
                localVarQueryParameter['p_addairps[]'] = pAddairps;
            }

            if (pLowLevelFc !== undefined) {
                localVarQueryParameter['p_low_level_fc'] = pLowLevelFc;
            }

            if (pSwa !== undefined) {
                localVarQueryParameter['p_swa'] = pSwa;
            }

            if (pRegion !== undefined) {
                localVarQueryParameter['p_region'] = pRegion;
            }

            if (pValidTime !== undefined) {
                localVarQueryParameter['p_valid_time'] = pValidTime;
            }

            if (pSigwx !== undefined) {
                localVarQueryParameter['p_sigwx'] = pSigwx;
            }

            if (pUwtFl1 !== undefined) {
                localVarQueryParameter['p_uwt_fl1'] = pUwtFl1;
            }

            if (pUwtFl2 !== undefined) {
                localVarQueryParameter['p_uwt_fl2'] = pUwtFl2;
            }

            if (pUwtFl4 !== undefined) {
                localVarQueryParameter['p_uwt_fl4'] = pUwtFl4;
            }

            if (pUwtFl5 !== undefined) {
                localVarQueryParameter['p_uwt_fl5'] = pUwtFl5;
            }

            if (pUwtFl7 !== undefined) {
                localVarQueryParameter['p_uwt_fl7'] = pUwtFl7;
            }

            if (pUwtFl9 !== undefined) {
                localVarQueryParameter['p_uwt_fl9'] = pUwtFl9;
            }

            if (pUwtFl11 !== undefined) {
                localVarQueryParameter['p_uwt_fl11'] = pUwtFl11;
            }

            if (pUwtFl13 !== undefined) {
                localVarQueryParameter['p_uwt_fl13'] = pUwtFl13;
            }

            if (productId !== undefined) {
                localVarQueryParameter['product_id'] = productId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LegacyApi - functional programming interface
 * @export
 */
export const LegacyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LegacyApiAxiosParamCreator(configuration)
    return {
        /**
         * Request for the legacy PHP server, retrieving a image or file.
         * @summary Get a file from the legacy server
         * @param {string} [url] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadLegacyFile(url?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadLegacyFile(url, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LegacyApi.downloadLegacyFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Request for the legacy PHP server, retrieving a OPMET file.
         * @summary Get OPMET file from the legacy server
         * @param {string} [icaoCode] 
         * @param {string} [pTt] 
         * @param {string} [pMinushour] 
         * @param {string} [format] 
         * @param {string} [pDept] 
         * @param {string} [section] 
         * @param {string} [pMode] 
         * @param {string} [pDest] 
         * @param {string} [pWaypnts] 
         * @param {string} [pAddairps] 
         * @param {string} [pLowLevelFc] 
         * @param {string} [pSwa] 
         * @param {string} [pRegion] 
         * @param {string} [pValidTime] 
         * @param {string} [pSigwx] 
         * @param {string} [pUwtFl1] 
         * @param {string} [pUwtFl2] 
         * @param {string} [pUwtFl4] 
         * @param {string} [pUwtFl5] 
         * @param {string} [pUwtFl7] 
         * @param {string} [pUwtFl9] 
         * @param {string} [pUwtFl11] 
         * @param {string} [pUwtFl13] 
         * @param {string} [productId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadLegacyOpmetFile(icaoCode?: string, pTt?: string, pMinushour?: string, format?: string, pDept?: string, section?: string, pMode?: string, pDest?: string, pWaypnts?: string, pAddairps?: string, pLowLevelFc?: string, pSwa?: string, pRegion?: string, pValidTime?: string, pSigwx?: string, pUwtFl1?: string, pUwtFl2?: string, pUwtFl4?: string, pUwtFl5?: string, pUwtFl7?: string, pUwtFl9?: string, pUwtFl11?: string, pUwtFl13?: string, productId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadLegacyOpmetFile(icaoCode, pTt, pMinushour, format, pDept, section, pMode, pDest, pWaypnts, pAddairps, pLowLevelFc, pSwa, pRegion, pValidTime, pSigwx, pUwtFl1, pUwtFl2, pUwtFl4, pUwtFl5, pUwtFl7, pUwtFl9, pUwtFl11, pUwtFl13, productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LegacyApi.downloadLegacyOpmetFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LegacyApi - factory interface
 * @export
 */
export const LegacyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LegacyApiFp(configuration)
    return {
        /**
         * Request for the legacy PHP server, retrieving a image or file.
         * @summary Get a file from the legacy server
         * @param {string} [url] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadLegacyFile(url?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.downloadLegacyFile(url, options).then((request) => request(axios, basePath));
        },
        /**
         * Request for the legacy PHP server, retrieving a OPMET file.
         * @summary Get OPMET file from the legacy server
         * @param {string} [icaoCode] 
         * @param {string} [pTt] 
         * @param {string} [pMinushour] 
         * @param {string} [format] 
         * @param {string} [pDept] 
         * @param {string} [section] 
         * @param {string} [pMode] 
         * @param {string} [pDest] 
         * @param {string} [pWaypnts] 
         * @param {string} [pAddairps] 
         * @param {string} [pLowLevelFc] 
         * @param {string} [pSwa] 
         * @param {string} [pRegion] 
         * @param {string} [pValidTime] 
         * @param {string} [pSigwx] 
         * @param {string} [pUwtFl1] 
         * @param {string} [pUwtFl2] 
         * @param {string} [pUwtFl4] 
         * @param {string} [pUwtFl5] 
         * @param {string} [pUwtFl7] 
         * @param {string} [pUwtFl9] 
         * @param {string} [pUwtFl11] 
         * @param {string} [pUwtFl13] 
         * @param {string} [productId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadLegacyOpmetFile(icaoCode?: string, pTt?: string, pMinushour?: string, format?: string, pDept?: string, section?: string, pMode?: string, pDest?: string, pWaypnts?: string, pAddairps?: string, pLowLevelFc?: string, pSwa?: string, pRegion?: string, pValidTime?: string, pSigwx?: string, pUwtFl1?: string, pUwtFl2?: string, pUwtFl4?: string, pUwtFl5?: string, pUwtFl7?: string, pUwtFl9?: string, pUwtFl11?: string, pUwtFl13?: string, productId?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.downloadLegacyOpmetFile(icaoCode, pTt, pMinushour, format, pDept, section, pMode, pDest, pWaypnts, pAddairps, pLowLevelFc, pSwa, pRegion, pValidTime, pSigwx, pUwtFl1, pUwtFl2, pUwtFl4, pUwtFl5, pUwtFl7, pUwtFl9, pUwtFl11, pUwtFl13, productId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LegacyApi - object-oriented interface
 * @export
 * @class LegacyApi
 * @extends {BaseAPI}
 */
export class LegacyApi extends BaseAPI {
    /**
     * Request for the legacy PHP server, retrieving a image or file.
     * @summary Get a file from the legacy server
     * @param {string} [url] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegacyApi
     */
    public downloadLegacyFile(url?: string, options?: RawAxiosRequestConfig) {
        return LegacyApiFp(this.configuration).downloadLegacyFile(url, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Request for the legacy PHP server, retrieving a OPMET file.
     * @summary Get OPMET file from the legacy server
     * @param {string} [icaoCode] 
     * @param {string} [pTt] 
     * @param {string} [pMinushour] 
     * @param {string} [format] 
     * @param {string} [pDept] 
     * @param {string} [section] 
     * @param {string} [pMode] 
     * @param {string} [pDest] 
     * @param {string} [pWaypnts] 
     * @param {string} [pAddairps] 
     * @param {string} [pLowLevelFc] 
     * @param {string} [pSwa] 
     * @param {string} [pRegion] 
     * @param {string} [pValidTime] 
     * @param {string} [pSigwx] 
     * @param {string} [pUwtFl1] 
     * @param {string} [pUwtFl2] 
     * @param {string} [pUwtFl4] 
     * @param {string} [pUwtFl5] 
     * @param {string} [pUwtFl7] 
     * @param {string} [pUwtFl9] 
     * @param {string} [pUwtFl11] 
     * @param {string} [pUwtFl13] 
     * @param {string} [productId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegacyApi
     */
    public downloadLegacyOpmetFile(icaoCode?: string, pTt?: string, pMinushour?: string, format?: string, pDept?: string, section?: string, pMode?: string, pDest?: string, pWaypnts?: string, pAddairps?: string, pLowLevelFc?: string, pSwa?: string, pRegion?: string, pValidTime?: string, pSigwx?: string, pUwtFl1?: string, pUwtFl2?: string, pUwtFl4?: string, pUwtFl5?: string, pUwtFl7?: string, pUwtFl9?: string, pUwtFl11?: string, pUwtFl13?: string, productId?: string, options?: RawAxiosRequestConfig) {
        return LegacyApiFp(this.configuration).downloadLegacyOpmetFile(icaoCode, pTt, pMinushour, format, pDept, section, pMode, pDest, pWaypnts, pAddairps, pLowLevelFc, pSwa, pRegion, pValidTime, pSigwx, pUwtFl1, pUwtFl2, pUwtFl4, pUwtFl5, pUwtFl7, pUwtFl9, pUwtFl11, pUwtFl13, productId, options).then((request) => request(this.axios, this.basePath));
    }
}

